export default function GuideIcon({ className = "h-7 w-7" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="sg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#F4E0A5" />
          <stop offset="1" stopColor="#D4E157" />
        </linearGradient>
      </defs>
      <circle cx="22" cy="26" r="17" fill="url(#sg)" stroke="#14352a" strokeWidth="1.5" />
      <path
        d="M9.5 18c6 2.5 9 8 9 16M34.5 34c-6-2.5-9-8-9-16"
        fill="none"
        stroke="#14352a"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="17" cy="24" r="1.6" fill="#14352a" />
      <circle cx="27" cy="24" r="1.6" fill="#14352a" />
      <path d="M17 30c2.5 3 7.5 3 10 0" fill="none" stroke="#14352a" strokeWidth="1.6" strokeLinecap="round" />
      <path
        d="M38 4l1.6 4.4L44 10l-4.4 1.6L38 16l-1.6-4.4L32 10l4.4-1.6z"
        fill="#fff"
        stroke="#14352a"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );
}
